import React, { useEffect } from "react";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import styles from "./App.module.scss";
import SideBar from "./components/SideBar";
import Home from "./pages/Home";
import Orders from "./pages/Orders";
import SelectWarehouse from "./pages/SelectWarehouse";
import ShippingFee from "./pages/ShippingFee";
import OrderShip from "./pages/OrderShip";
import ZeroWasteFee from "./pages/ZeroWasteFee";
import Recycle from "./pages/Recycle";
import RecycledProduct from "./pages/RecycledProduct";
import Driver from "./pages/Driver";
import StorageService from "./services/StorageService";
import { jwtDecode } from "jwt-decode";
import loginApi from "./apis/loginApi";
  
import DriverProfile from "./pages/DriverProfile";
import IncomeReport from "./pages/IncomeReport";
import AdminDriverIncome from "./pages/AdminDriverIncome";

// Synchronously initialize token and driver info from URL query params (for cross-domain redirects)
if (typeof window !== "undefined" && window.location.search) {
  const syncParams = new URLSearchParams(window.location.search);
  const syncToken = syncParams.get("token");
  const syncRole = syncParams.get("role");
  const syncDriverId = syncParams.get("driverId");
  const syncDriverName = syncParams.get("driverName");
  const syncDriverPhone = syncParams.get("driverPhone");

  if (syncToken) {
    StorageService.token = syncToken;
    if (syncRole) {
      localStorage.setItem("userRole", syncRole);
    }
    if (syncDriverId) {
      localStorage.setItem("driverId", syncDriverId);
    }
    if (syncDriverName) {
      localStorage.setItem("driverName", syncDriverName);
    }
    if (syncDriverPhone) {
      localStorage.setItem("driverPhone", syncDriverPhone);
    }
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}

function App() {
  const navigate = useNavigate();
  
  useEffect(()=> {
    if (!StorageService.token) {
      navigate('/login')
    } else {
      const currentRole = localStorage.getItem("userRole");
      if (currentRole === "driver" && window.location.pathname === "/") {
        navigate('/orders-ship');
      }
    }
  },[navigate])

  useEffect(() => {
    const token = StorageService.token;
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        
        if (decodedToken && decodedToken.exp && decodedToken.exp < Date.now() / 1000) {
          if (process.env.NODE_ENV !== 'development') {
            StorageService.token = "";
            navigate("/login");
          }
        }
      } catch (err) {
        // Ignored for non-JWT tokens like "driver_..."
      }
    }
  }, [navigate]);

  return (
    <div className={styles.root}>
      <div className={styles.sidebarWrap}>
        <SideBar />
      </div>
      <div className={styles.contentWrap}>
        <Routes>
          <Route path="/" element={localStorage.getItem("userRole") === "driver" ? <Navigate to="/orders-ship" replace /> : <Home />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/shipping-fee" element={<ShippingFee />} />
          <Route path="/orders-ship" element={<OrderShip />} />
          <Route path="/select-warehouse" element={<SelectWarehouse />} />
          <Route path="/zero-waste-fee" element={<ZeroWasteFee />} />
          <Route path="/recycles" element={<Recycle/>} />
          <Route path="/recycled-products" element={<RecycledProduct />} />
          <Route path="/drivers" element={<Driver />} />
          <Route path="/driver-incomes" element={<AdminDriverIncome />} />
          <Route path="/income-report" element={<IncomeReport />} />
          <Route path="/driver-profile" element={<DriverProfile />} />
          <Route path="*" element={<div>Not found</div>} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
